import { render } from "./listaespera.vue?vue&type=template&id=55176dc8&scoped=true"
import script from "./listaespera.vue?vue&type=script&lang=js"
export * from "./listaespera.vue?vue&type=script&lang=js"

import "./listaespera.vue?vue&type=style&index=0&id=55176dc8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55176dc8"]])

export default __exports__